import { Nature } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import BaseProfilEcritureDepense from './Base/BaseProfilEcritureDepense';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import DelaiPaiementPanel from '../panel/DelaiPaiementPanel';
import FctvaPanel from '../panel/FctvaPanel';
import InformationsChorusProPanel from '../panel/InformationsChorusProPanel';
import InventairePanel from '../panel/InventairePanel';
import ProjetPanel from '../panel/ProjetPanel';

class ProfilEcritureTravauxRegieAvecInfoInventaireDepense extends BaseProfilEcritureDepense {
  constructor() {
    super();
    this.code = PROFIL_ECRITURE.DEPENSE.TRAV_REGIE_AVEC_INFO_INV;
    this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.DEPENSE.INVENTAIRE;
    this.typePiece = TYPE_PIECE.DEPENSE.ORDRE_BUDGET;
    this.imputation.nature = Nature.ORDRE;
    this.imputation.chapitre = '040';
    this.imputation.articles = ['2'];
    this.modeDeReglement = [
      MODE_REGLEMENT.DEPENSE.OPERATION_ORDRE,
      MODE_REGLEMENT.DEPENSE.VIREMENT_INTERNE,
    ];
    this.panels = [
      new CompteDeTiersPanel(),
      new CovidPanel(),
      new DelaiPaiementPanel(true),
      new FctvaPanel(),
      new InformationsChorusProPanel(),
      new InventairePanel(true),
      new ProjetPanel(),
    ];
  }
}

export default ProfilEcritureTravauxRegieAvecInfoInventaireDepense;
